import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import HeaderTwo from "../components/common/headerTwo";
import Footer from "../components/common/footer";

import Hero from "../components/knowledge/hero"; 
import { postsData } from '../data/postData';

function KnowledgeBase() {
  return (
    <>
      <Helmet>
        <title>Baza wiedzy i porady | Drzewus</title>
        <meta name="title" content="Baza wiedzy i porady | Drzewus" />
        <meta
          name="description"
          content="Poznaj nasze porady eksperckie dotyczące wycinki drzew, zakładania ogrodów, mulczowania oraz prac ziemnych."
          key="desc"
        />
        <meta property="og:title" content="Baza wiedzy i porady | Drzewus" />
        <meta
          property="og:description"
          content="Poznaj nasze porady eksperckie dotyczące wycinki drzew, zakładania ogrodów, mulczowania oraz prac ziemnych."
        />
        <meta
          property="og:image"
          content="https://yourdomain.com/path/to/og-image.png"
        />
      </Helmet>
      
      <HeaderTwo />
      
      <main className="relative z-40">
        <Hero />
        
  
        <section className="p-6 lg:px-24 lg:py-16 max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {postsData.map((post) => (
              <div key={post.id} className="border border-gray-100 rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-all flex flex-col bg-white">
                <img src={post.imageUrl} alt={post.title} className="w-full h-56 object-cover" />
                <div className="p-6 flex flex-col flex-grow">
                  <p className="text-sm text-gray-400 mb-2 font-semibold">{post.date}</p>
                  <h2 className="text-xl font-bold mb-3 color-green">{post.title}</h2>
                  <p className="text-gray-600 mb-6 flex-grow line-clamp-3">{post.excerpt}</p>
                  
                  <Link 
                    to={`/baza-wiedzy/${post.slug}`} 
                    className="button-green w-full text-center py-3"
                  >
                    Czytaj dalej
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
      
      <Footer />
    </>
  );
}

export default KnowledgeBase;